<div class="job-dialog">

  <div class="content">

    <h1> {{ isNew ? 'Nouveau job' : 'Editer job' }} </h1>

    <!-- {{ data | json }}  -->

    <form #jobForm="ngForm" class="job-form">

      @if (job.serviceType === ServiceType.INTERMEDIATION) {
        <h3>{{selectedCar.make}} {{selectedCar.model}} {{selectedCar.version}}</h3>
      }

      @if (job.serviceType !== ServiceType.INTERMEDIATION) {
        <mat-form-field>
          <mat-label>Véhicule</mat-label>
          <mat-select required name="car" [(ngModel)]="job.carId">
            @for (car of (myCars$ | async); track car) {
              <mat-option [value]="car.carId" >{{car.make}} {{car.model}} {{car.version}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      <mat-form-field>
        <mat-label>Service</mat-label>
        <mat-select required name="serviceType" [(ngModel)]="job.serviceType">
          @for (type of serviceTypesBD; track type) {
            <mat-option [value]="type.code" >{{type.title}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <!--
      <mat-form-field>
        <mat-label>Type d'activité/prestation</mat-label>
        <mat-select required name="jobType" [(ngModel)]="job.jobType">
          <mat-option *ngFor="let type of jobTypesBD" [value]="type.code" >{{type.title}}</mat-option>
        </mat-select>
      </mat-form-field> -->

      @if (job.serviceType === ServiceType.REPAIR) {
        <mat-form-field>
          <mat-label>Catégorie de prestations</mat-label>
          <mat-select name="jobCategories" multiple [(ngModel)]="job.jobCategories">
            @for (serv of jobCategoriesBD; track serv) {
              <mat-option [value]="serv.code" >{{serv.title}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      <mat-form-field >
        <mat-label >Titre</mat-label>
        <input required matInput type="text" matNativeControl  name ="title" placeholder="Titre"  [(ngModel)]="job.title" >
      </mat-form-field>

      <mat-form-field >
        <mat-label >Description</mat-label>
        <textarea required matInput type="text"  name ="description" placeholder=""  [(ngModel)]="job.description" ></textarea>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Lieu du rendez vous</mat-label>
        <mat-select name="locationMode" (selectionChange)="onLocationModeChange()" [(ngModel)]="job.locationMode" required>
          @for (loc of locationModesBD; track loc) {
            <mat-option [value]="loc.code" >{{loc.title}}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field >
        <mat-label >Message</mat-label>
        <textarea matInput type="text"  name ="details" placeholder=""  [(ngModel)]="job.details" ></textarea>
      </mat-form-field>

      <h5>Urgence ?

        <mat-slide-toggle
          class="example-margin"
          name = "emergency"
          [disabled]="false"
          [(ngModel)]="job.emergency"
          (change)="onEmergencyChange() ">

        </mat-slide-toggle>
      </h5>

      <mat-form-field >
        <mat-label>Date Activité </mat-label>
        <input matInput [matDatepicker]="picker" name="jobDate" [(ngModel)]="job.scheduledDate">
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

    </form>

    <!-- <div mat-dialog-actions class="action-buttons"> -->
    <div class="action-buttons">
      <button class="simple-button-keep" mat-button [mat-dialog-close]="">Annuler</button>
      <button class="cta-button-keep" [disabled] = !jobForm.valid mat-button [mat-dialog-close]="job" (click)="submitJob();$event.stopPropagation()"> Soumettre </button>
    </div>
  </div>
</div>